import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-success-modal',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
    exportAs: 'bs-modal'
})
export class SuccessComponent {
    @ViewChild('smModal')
    public smModal: ModalDirective;

    public successMessage: string;
    constructor(
    ) { }

    show(successMessage: string) {
        this.successMessage = successMessage;
        this.smModal.show();
    }

    hide() {
        this.smModal.hide();
    }
}
